import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '../api.js';
import { t, wanneer } from '../i18n.js';

/**
 * Het logboek. Elke regel is een Nederlandse sleutel met waarden en wordt hier vertaald, zodat een
 * regel van gisteren vandaag in het Engels te lezen is.
 */
export default function Logboek({ klant }) {
  const q = useInfiniteQuery({
    queryKey: ['logboek', klant],
    queryFn: ({ pageParam }) => api.logboek({ tenant: klant, before: pageParam }),
    initialPageParam: undefined,
    getNextPageParam: (laatste) => laatste.next ?? undefined,
  });
  const regels = q.data?.pages.flatMap((p) => p.data) ?? [];

  return (
    <>
      <div className="page-head"><div>
        <h1>{t('Logboek')}</h1>
        <p className="sub">{t('Wie deed wat in ADTS ZERO. Niets is te wijzigen of te verwijderen, ook niet door een beheerder.')}</p>
      </div></div>
      <section className="card">
        {q.isPending ? <p className="muted">{t('Laden…')}</p>
          : q.isError ? <div className="melder rood">{t(q.error.message)}</div>
          : !regels.length ? <p className="empty">{t('Nog niets in het logboek.')}</p>
          : (
            <table>
              <thead><tr><th>{t('Wanneer')}</th><th>{t('Wie')}</th><th>{t('Wat')}</th><th className="hide-sm">{t('Vanaf')}</th></tr></thead>
              <tbody>
                {regels.map((r) => (
                  <tr key={r.id}>
                    <td className="mono muted">{wanneer(r.at)}</td>
                    <td>{r.actor ? <>{r.actor.name || r.actor.number}<br /><span className="muted mono">{r.actor.number}</span></> : <span className="muted">{t('ADTS ZERO')}</span>}</td>
                    <td>{r.tenant && <span className="ttag">{r.tenant.name}</span>} {t(r.key, r.params)}</td>
                    <td className="hide-sm mono muted">{r.ip ?? ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        {q.hasNextPage && (
          <div className="actions">
            <button className="btn" disabled={q.isFetchingNextPage} onClick={() => q.fetchNextPage()}>{t('Oudere regels')}</button>
          </div>
        )}
      </section>
    </>
  );
}
